import { Fragment, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Box, FormControl, FormLabel, Grid, GridItem, Heading, Input, IconButton, Button, Select } from '@chakra-ui/react'
import { MdOutlineDelete } from 'react-icons/md'
import { QUOTE_ADDITIONAL_ITEM_CATEGORIES } from 'lib'

export const EdgeAdditionalItemsForm = ({ form, setForm, ...rest }) => {
  const [itemId, setItemId] = useState(1)

  useEffect(() => {
    let maxId = 0
    form.additionalItems.forEach(item => {
      if (item.id > maxId) {
        maxId = item.id
      }
    })
    setItemId(maxId + 1)
  }, [])

  const handleChange = (id, field, value) => {
    const newItems = form.additionalItems.map(item => {
      if (item.id === id) {
        return { ...item, [field]: value }
      } else {
        return { ...item }
      }
    })

    let total = 0
    newItems.forEach(item => { total += item.price * 1 })

    setForm(draft => {
      draft.additionalItems = newItems
      draft.additionalItemsCost = parseFloat(total.toFixed(2))
    })
  }

  const handleDelete = (id) => {
    const newItems = form.additionalItems.filter(item => item.id !== id)

    let total = 0
    newItems.forEach(item => { total += item.price * 1 })

    setForm(draft => {
      draft.additionalItems = newItems
      draft.additionalItemsCost = parseFloat(total.toFixed(2))
    })
  }

  const handleAdd = () => {
    const newItems = form.additionalItems.map(item => ({ ...item }))
    const nextId = Math.max(itemId, ...newItems.map(item => item.id + 1), 1)
    newItems.push({ id: nextId, category: '', description: '', price: 0 })
    setItemId(nextId + 1)
    setForm(draft => {
      draft.additionalItems = newItems
    })
  }

  return (
    <Box {...rest}>
      <Grid
        templateColumns="5fr 1fr"
        rowGap={5}
        columnGap={10}
        w="900px"
        maxW="100%"
      >
        <GridItem>
          <Heading size="md">Additional Items</Heading>
        </GridItem>
        <GridItem></GridItem>
        {form.additionalItems.map(item => {
          return (
            <Fragment key={item.id}>
              <GridItem display="flex" alignItems="flex-end" gap={4}>
                <IconButton
                  size="sm"
                  colorScheme="gray"
                  icon={<MdOutlineDelete fontSize="16px" />}
                  onClick={() => handleDelete(item.id)}
                />
                <Grid
                  templateColumns="repeat(4, 1fr)"
                  gap={4}
                  w="100%"
                >
                  <GridItem colSpan={1}>
                    <FormControl isRequired>
                      <FormLabel>Category</FormLabel>
                      <Select
                        value={item.category}
                        onChange={e => handleChange(item.id, 'category', e.target.value)}
                        placeholder="Select"
                      >
                        {Object.entries(QUOTE_ADDITIONAL_ITEM_CATEGORIES).map(([key, value]) => {
                          return <option key={key} value={value}>{value}</option>
                        })};
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem colSpan={3}>
                    <FormControl isRequired>
                      <FormLabel>Description</FormLabel>
                      <Input value={item.description} onChange={e => handleChange(item.id, 'description', e.target.value)} />
                    </FormControl>
                  </GridItem>
                </Grid>
              </GridItem>
              <GridItem>
                <FormControl isRequired>
                  <FormLabel>Price</FormLabel>
                  <Input
                    type="number"
                    value={item.price}
                    onChange={e => handleChange(item.id, 'price', parseFloat(e.target.value))}
                    onBlur={e => handleChange(item.id, 'price', parseFloat(e.target.value || 0).toFixed(2))}
                  />
                </FormControl>
              </GridItem>
            </Fragment>
          )
        })}
        <GridItem display="flex" alignItems="flex-end">
          <Button size="sm" onClick={handleAdd}>Add Additional Items</Button>
        </GridItem>
        <GridItem>
          <GridItem display="flex" alignItems="flex-end" justifyContent="flex-end">
            <FormControl>
              <FormLabel>Additional Cost</FormLabel>
              <Input value={form.additionalItemsCost} readOnly />
            </FormControl>
          </GridItem>
        </GridItem>
      </Grid>
    </Box>
  )
}

EdgeAdditionalItemsForm.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func
}
